<template>
  <hlt-text
    v-if="formattedViews"
    class="asset-page-footer-meta-component"
    :size="'sm'"
    :variant="'content-secondary'"
  >
    {{ formattedViews }} <span>Views</span>
  </hlt-text>
</template>

<script>
import HltText from '@/components/ui/text.vue';

export default {
  components: {HltText},
  props: {
    asset: {
      type: Object,
    },
    totalViews: {
      type: Number,
    },
  },
  computed: {
  formattedViews() {
    const n = Number(this.totalViews);
    if (!Number.isFinite(n) || n <= 0) return '';
    return n.toLocaleString();
   },
 },
};
</script>

<style lang="scss" scoped>
.asset-page-footer-meta-component {
  text-align: center;
}
</style>
